import {getOnKeyDownProp} from '@/lib/utils/a11y';
import {useEmitEventOnClick} from '@/lib/utils/analytics';
import {getOfferStoreUrl} from '@/lib/utils/catalog.utils';
import {AnalyticEventProps} from '@/types';
import {Card, CardProps} from '@eds-web/react';
import {css, cx} from '@panda/css';
import {CatalogOffer} from 'epic-graphql-types';
import {SyntheticEvent} from 'react';

interface CatalogLinkOfferCardCardProps {
	cardProps: CardProps;
	offer: CatalogOffer;
	analytics?: AnalyticEventProps;
	locale: string;
}

export const CatalogLinkOfferCard = (props: CatalogLinkOfferCardCardProps) => {
	const emitEvent = useEmitEventOnClick(props.analytics!);
	const href = getOfferStoreUrl(props.offer)! || '#';

	const onClick = <T extends Element>(e: SyntheticEvent<T>) => {
		emitEvent(e, {
			status: 'initiate',
			offerId: props.offer.id,
			sandboxId: props.offer.namespace
		});
	};

	return (
		<Card
			{...props.cardProps}
			title={props.cardProps.title || ' '}
			variant="ghost"
			imageAspectRatio="3:4"
			imageMode="single"
			className={cx(props.cardProps.className, css({width: '100%'}))}
			data-testid="use-pdp"
			clickOverlayProps={{href, onClick}}
			onKeyDown={getOnKeyDownProp((e) => {
				onClick(e);
				window.location.href = href;
			})}
		/>
	);
};
